import { combineTokens } from '@utils/css';

const tokens = combineTokens("--printer-size", {
  physicalPageHeightInMM: "10",
  physicalPageWidthInMM: "10",
  designWidthInPx: "10",
  designHeightInPx: "10"
});
const pxToMMConversionCls = "_7cp1deteku";

export { pxToMMConversionCls, tokens };
import "./shared.size-tokens.style.linaria.module.css";
//# sourceMappingURL=shared.size-tokens.style.js.map
